var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name === 'fenaju.tarefas'),expression:"$route.name === 'fenaju.tarefas'"}],staticClass:"console-tarefas console-pad"},[_c('div',{staticClass:"cliente-tarefas"},[_c('task-list-page',{ref:"list",attrs:{"autoload":true}})],1)]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }